import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RequestService } from './request.service';
import { UserCredentials } from '../models/Credentials.model';
import { RoleEnum } from '../models/enums/RoleEnum';
import { Feature } from '../models/feature.model';
import { MatDialog } from '@angular/material/dialog';
import { ModalDialog } from '../Modal/modal';
import { AuthenticationResponse } from '../models/authenticationresponse.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AuthService {
  public isTokenRefreshing: boolean = false;
  public tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

  constructor(
    private router: Router,
    private requestService: RequestService,
    private dialog: MatDialog
  ) {
  }

  public get authenticationResponseValue(): AuthenticationResponse {
    return JSON.parse(sessionStorage.getItem('AuthenticationResponse')) != null ? <AuthenticationResponse>JSON.parse(sessionStorage.getItem('AuthenticationResponse')) : null;
  }

  refreshToken(): Observable<any> {
    let credentials: UserCredentials = new UserCredentials();
    credentials.refreshToken = this.getCurrenAuthenticationResponse().refreshToken;
    return this.requestService.refreshToken(credentials);
  }

  authenticateUser(credentials: UserCredentials) {
    return this.requestService.Authenticate(credentials);
  }

  public authenticationSucces(response: any) {
    if (response != null) {
      if (response.token && response.token != '') {
        this.setSession(response);
        this.setLoginStatus();
        this.routeUserToStartpage();
      }
      else {
        this.openAlertDialog(response.error);
      }
    }
  }

  public authenticationError(error) {
    this.openAlertDialog(error.error);
  }

  openAlertDialog(message: string) {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: message,
        showCancel: false,
        saveButtonText: 'Okay'
      }
    });
  }

  logout() {
    const dialogRef = this.dialog.open(ModalDialog, {
      data: {
        title: 'Warning',
        message: 'Are you sure that you want to logout?',
        showCancel: true,
        cancelButtonText: 'Cancel',
        saveButtonText: 'Logout'
      }
    });

    dialogRef.afterClosed()
      .subscribe(result => {
        if (result) {
          this.logoutInternal();
        }
      });
  }

  logoutWithoutUserPermission() {
    this.logoutInternal();
  }

  private logoutInternal() {
    this.deleteAllStorage();
    this.router.navigate(['login']);
  }

  public isAuthenticated(): boolean {
    return this.authenticationResponseValue && this.authenticationResponseValue.token ? true : false;
  }

  public isLoggedIn() {
    return sessionStorage.getItem('loginstatus') == '1';
  }
  public getCurrenAuthenticationResponse(): AuthenticationResponse {
    return this.authenticationResponseValue;
  }

  public getCurrentAccessToken(): string {
    return this.authenticationResponseValue && this.authenticationResponseValue.token ? this.authenticationResponseValue.token : null;
  }

  public getCurrentCompanyId(): number {
    return this.authenticationResponseValue && this.authenticationResponseValue.companyId ? this.authenticationResponseValue.companyId : null;
  }

  public getCurrentUserId(): number {
    return this.authenticationResponseValue && this.authenticationResponseValue.userId ? this.authenticationResponseValue.userId : null;
  }

  public getCurrentRoleId(): number {
    return this.authenticationResponseValue && this.authenticationResponseValue.roleId ? this.authenticationResponseValue.roleId : null;
  }

  public getCurrentEmail(): string {
    return this.authenticationResponseValue && this.authenticationResponseValue.email ? this.authenticationResponseValue.email : null;
  }

  public getCurrentFeatures(): Feature[] {
    return this.authenticationResponseValue && this.authenticationResponseValue.features ? this.authenticationResponseValue.features : null;
  }

  public setSession(value) {
    sessionStorage.setItem('AuthenticationResponse', JSON.stringify(value));
  }

  private setLoginStatus() {
    sessionStorage.setItem('loginstatus', '1');
  }

  public deleteAllStorage() {
    sessionStorage.removeItem('fileImport');
    sessionStorage.removeItem('fileImportDeleteTravelMixes');
    sessionStorage.removeItem('loginstatus');
    sessionStorage.removeItem('AuthenticationResponse');
  }

  public routeUserToStartpage() {
    if (this.getCurrentRoleId() === RoleEnum["Super Admin"]) {
      this.router.navigate(['datamanagement/list']);
    }
    else if (this.getCurrentRoleId() === RoleEnum["Company Admin"]) {
      this.router.navigate(['project/list']);
    }
    else {
      this.router.navigate(['project/list']);
    }
  }
}